package com.schoolconnect.app.repository.files

private val MimeTypeExtensions = mapOf(
    "application/pdf" to "pdf",
    "application/msword" to "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" to "docx",
    "application/vnd.ms-excel" to "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" to "xlsx",
    "application/vnd.ms-powerpoint" to "ppt",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation" to "pptx",
    "text/plain" to "txt",
    "text/csv" to "csv",
    "application/zip" to "zip",
    "image/jpeg" to "jpg",
    "image/png" to "png",
    "image/gif" to "gif",
    "image/webp" to "webp"
)

internal fun appendMimeTypeExtension(filename: String, mimeType: String): String {
    val normalizedName = filename.trim().ifBlank { "download" }
    if (normalizedName.substringAfterLast('/').contains('.')) return normalizedName
    val extension = MimeTypeExtensions[mimeType.trim().substringBefore(';').lowercase()] ?: return normalizedName
    return "$normalizedName.$extension"
}

internal fun mimeTypeForDocumentType(fileType: String): String = when (fileType.trim().uppercase()) {
    "PDF" -> "application/pdf"
    "DOC" -> "application/msword"
    "DOCX" -> "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    "XLS" -> "application/vnd.ms-excel"
    "XLSX" -> "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    "PPT" -> "application/vnd.ms-powerpoint"
    "PPTX" -> "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    else -> "application/octet-stream"
}
